import { render } from "./PriceCheck.vue?vue&type=template&id=5f14f354&scoped=true"
import script from "./PriceCheck.vue?vue&type=script&lang=js"
export * from "./PriceCheck.vue?vue&type=script&lang=js"

import "./PriceCheck.vue?vue&type=style&index=0&id=5f14f354&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f14f354"]])

export default __exports__